import { createPortal } from "react-dom";

// Renders children as a direct child of <body>, escaping any ancestor
// stacking context (e.g. the sticky topbar inside the grid shell) so modals
// always sit on the very top layer.
export function Portal({ children }) {
  return typeof document !== "undefined" ? createPortal(children, document.body) : null;
}
